module.exports = __webpack_public_path__ + "img/UG.2c68ee31.svg";